import React, { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../../Firebase";
import { onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = (props) => {
  const [appUser, setUser] = useState(null);
  const [isLogin, setLogin] = useState(false);

  useEffect(() => {
    try {
      onAuthStateChanged(auth, async (user) => {
        console.log(user);
        setUser(user);
        if (user == null) {
          setUser(null);
          setLogin(false);
          console.log("user absent\n" + appUser);
        } else {
          console.log("user present\n" + user.displayName);
          setUser(user);
          setLogin(true);
          console.log("app User: " + appUser);
        }
      });
    } catch {
      console.log("Issue with try Catch");
    }
  }, []);

  const value = {
    appUser,
    setUser,
    isLogin,
    setLogin,
  };

  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
};
